import React from "react";
import TransactionsPanel from "../components/TransactionsPanel";
import useSeo from "../lib/useSeo";
import { useTranslation } from "react-i18next";

/**
 * Transactions get their own page again. Folding them into Holdings behind a
 * collapsible worked while the app was small, but transaction history is a
 * destination in its own right — people come here specifically to find or correct
 * an entry, and a collapsed panel three scrolls down is the wrong home for that.
 * The panel component is shared, so Holdings can still embed a copy if wanted.
 */
export default function Transactions() {
  const { t } = useTranslation();
  useSeo({ title: t("transactions.title"), noindex: true });
  return (
    <div className="space-y-6">
      <div>
        <span className="label">{t("transactions.fullRecord")}</span>
        <h1 className="text-3xl sm:text-4xl font-heading font-semibold tracking-tighter mt-1">
          {t("transactions.title")}
        </h1>
      </div>
      <TransactionsPanel alwaysOpen />
    </div>
  );
}
